import _ from "underscore";

import View from "backdraft-app/src/view";

import ActionBarButton from "./action_bar_button";
import Toast from "shared/toast";

const EditableControls = View.extend({
  tagName: "span",

  className: "editable-controls",

  template: `
      <div data-mount="buttons-area">
        <button class="btn btn-primary btn-icon" data-action="save">
          <i class="material-icons">check</i>
        </button>
        <button class="btn btn-default btn-icon" data-action="cancel">
          <i class="material-icons">close</i>
        </button>
      </div>
    `,

  events: {
    "click button[data-action='save']": "_onSaveClick",
    "click button[data-action='cancel']": "_onCancelClick"
  },

  initialize(options = {}) {
    this.buttons = options.buttons || [];
    this.beforeSave = options.beforeSave;
    this.row = options.row;
    this.editModel = options.editModel;
  },

  render() {
    this.$el.html(this.template);
    const buttonViews = _.map(this.buttons, function(config) {
      const view = new ActionBarButton(config).render();
      view.$el.removeClass("filter-area-item");
      this.child(`button-${view.cid}`, view);
      return view;
    }, this);
    this.$("[data-mount='buttons-area']").append(_.pluck(buttonViews, "$el"));
    return this;
  },

  displayErrors(errors) {
    const messageNodes = [];
    const view = this.parent;
    const table = view && view.children.dataTable;

    function addErrorMsg(attr, msg) {
      if (msg.slice(-1) !== ".") {
        msg += ".";
      }

      let attrFriendlyName = "";

      if (attr.toLowerCase() !== "base" && !view.deprecatedErrors) {
        if (table && table._columnManager.columnConfigForId(attr)) {
          attrFriendlyName = `${table._columnManager.columnConfigForId(attr).title} `;
        } else {
          attrFriendlyName = attr.replace(/_/g, ' ');
          attrFriendlyName = `${attrFriendlyName[0].toUpperCase() + attrFriendlyName.substring(1)} `;
        }
      }

      messageNodes.push(attrFriendlyName + msg);
    }

    _.each(errors, (messages, attr) => {
      _.each(messages, msg => { addErrorMsg(attr, msg); });
    });

    if (messageNodes.length) {
      Toast.error({
        title: "Unable to save row",
        message: messageNodes.join("<br />"),
        sticky: true
      });
    }
  },

  toggleSaving() {
    this.$("[data-mount='buttons-area'] .btn").toggleClass("disabled");
  },

  _onSaveClick() {
    Toast.clear();
    const self = this;
    const proceed = function() {
      self.trigger(...["save"].concat(_.toArray(arguments)));
    };
    if (this.beforeSave) {
      this.beforeSave(this.editModel, this.row.model, proceed);
    } else {
      proceed();
    }

    return false;
  },

  _onCancelClick() {
    Toast.clear();
    this.trigger("cancel");
    return false;
  }
});

export default EditableControls;
